var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackrightupicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8797_44734",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 15,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.09375 2.75001H15.0516V17.375H1.09375L1.09375 2.75001Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8797_44734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.10938 4.67184H13.0185V11.9111",
    stroke: "#111111",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2423 4.4375L3.36523 14.7866",
    stroke: "#111111",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackrightupicon);
export default __webpack_public_path__ + "static/media/blackrightupicon.63d6db5b9cf16fbadcc37c7db567c39a.svg";
export { ForwardRef as ReactComponent };